import { useState, useEffect } from "react";
import { Box, Button, Tooltip, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import CheckIcon from "@mui/icons-material/Check";
import { toMoney } from "../../util/Utils";
import { UseComment } from "./UseComment";
import { UseMyPC } from "../../hooks/UseMyPC";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import { Link } from "react-router-dom";
import CommentsAcc from "./CommentsAcc";

export default function GridContent(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { ProductComments, getOrders } = UseComment();
  const navigate = useNavigate();
  const [gridState, setGridState] = useState("comments");
  const [commentsRes, setCommentsRes] = useState([]);
  const [pageState, setPageState] = useState({
    page: 1,
    page: 1,
    scrollTo: undefined,
  });

  useEffect(() => {
    setProgress(true);
    if (gridState == "comments") {
      ProductComments(
        pageState.page,
        props.profileRes.mobile,
        "",
        "",
        "",
        (comments) => {
          setCommentsRes(comments.items);
        }
      );
    }
  }, [pageState.page, props.profileRes, gridState]);

  return (
    <Box sx={{ pb: "20px", height: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}></Box>
      <Box sx={{ height: "25rem" }}>
        {gridState == "comments" && (
          <CommentsAcc
            mobile={props.profileRes.mobile}
            commentsRes={commentsRes}
          ></CommentsAcc>
        )}
      </Box>
    </Box>
  );
}
